// 公开富文本展示前移除脚本、事件属性和危险协议。
export function safeHtml(value) {
  if (!value) return ''
  if (typeof DOMParser === 'undefined') return String(value).replace(/<script[\s\S]*?<\/script>/gi, '')
  const doc = new DOMParser().parseFromString(String(value), 'text/html')
  doc.querySelectorAll('script,style,iframe,object,embed,form').forEach(node => node.remove())
  doc.querySelectorAll('*').forEach(node => Array.from(node.attributes).forEach(attr => {
    const name = attr.name.toLowerCase(); const val = attr.value.trim().toLowerCase()
    if (name.indexOf('on') === 0 || ((name === 'href' || name === 'src' || name === 'xlink:href') && val.indexOf('javascript:') === 0)) node.removeAttribute(attr.name)
  }))
  return doc.body.innerHTML
}
